// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChatBotComponent_chatbotMiddle__4oGeB {
    /* display: flex;
    justify-content: center;
    margin: 10px 0;
    position: relative;
    bottom: auto;
    height: 90%;
    align-items: center; */
    /* width: 100%; */
    position: fixed;
    bottom: -10px;
    width: 100%;
}

.ChatBotComponent_chatbotBottom__MVlRN {
    /* display: flex;
    justify-content: center;
    margin: 10px 0;
    bottom: 10px;
    width: 100%; */
    position: fixed;
    bottom: -10px;
    width: 100%;
}

.ChatBotComponent_messages__y1IRN {
    flex: 1 1;
    overflow-y: auto;
    margin-bottom: 10px;
    padding: 20px;
    height: 73vh;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-left: 10%;
    padding-right: 10%;
    /* overflow: initial; */

}

.ChatBotComponent_tipsClass__W\\+kCb{
    text-align:"left";
    margin-left: 25px;
}

.ChatBotComponent_tipsIcon__EdBGW{
    height: 15px !important;
    width: 15px !important;
    margin-bottom: 5px;
    margin-right: 2px;
    margin-left: -6px;
}

/* .messages::-webkit-scrollbar {
    display: none;
}

.messages {
  -ms-overflow-style: none; 
  scrollbar-width: none; 
} */

.ChatBotComponent_messages__y1IRN img {
    width: 70% ;
    height: 70% ;
}

.ChatBotComponent_sentMessage__5xVJl {
    padding: 2px 10px;
    margin-bottom: 5px;
    border-radius: 30px;
    max-width: 70%;
    position: relative;
    background-color: #e3e3e3;
    border: 0 solid #e3e3e3;
    min-width: 8%;
    float: right;
    text-align: center;
    overflow-wrap: anywhere;
    border-radius: 5px;
    border: 1px solid #D7E5F8;
    background: #EFF5FC;
    color: #3A3A3A;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
}

.ChatBotComponent_receivedMessage__gomBX {
    margin: 5px 0;
    padding: 5px 25px;
    border-radius: 5px;
    position: relative;
    border: 1px solid #D7E5F8;
    background-color: #faf9f9;
    min-width: 8%;
    overflow-wrap: anywhere;
    max-width: 80%;
}

.ChatBotComponent_mainDiv__Ova9Z {
    width: 100%;
    margin-top: 70px;
    font-size: 12px;
}

.ChatBotComponent_userFeedbackContainer__QdU-n {
    background-color: #f7f7f7;
    height: 100vh;
}


.ChatBotComponent_gridContainer__tmior {
    height: 93.2vh;
}

/* side panel */
.ChatBotComponent_sidePanelTrigger__xxboi {
    position: fixed;
    left: 10px;
    top: 10%;
    transform: translateY(-50%);
    width: 30px;
    height: 100px;
    /* background-color: #000; */
    content: "Joe's Task: ";
    cursor: pointer;
    writing-mode: vertical-rl;
    display: flex;
    justify-content: center;
}

.ChatBotComponent_sidePanel__n7chF {
    position: fixed;
    left: -250px;
    top: 0;
    width: 200px;
    height: 70%;
    margin-top: 3% !important;
    background-color: #f4f4f4;
    transition: left 0.3s ease;
    box-shadow: 2px 0 5px rgba(206, 11, 11, 0.1);
}

.ChatBotComponent_sidePanelContent__l4PlS {
    padding: 20px;
}

/* Hover effect */
.ChatBotComponent_sidePanelTrigger__xxboi:hover+.ChatBotComponent_sidePanel__n7chF,
.ChatBotComponent_sidePanel__n7chF:hover {
    left: 0;
}

.ChatBotComponent_rightSidePanelTrigger__9ZQgp {
    position: fixed;
    right: 10px;
    top: 10%;
    transform: translateY(-50%);
    width: 30px;
    height: 100px;
    cursor: pointer;
    writing-mode: vertical-rl;
    display: flex;
    justify-content: center;
}

.ChatBotComponent_rightSidePanel__yduMd {
    position: fixed;
    right: -600px;
    top: 0;
    width: 30%;
    height: 93%;
    margin-top: 3% !important;
    background-color: #f4f4f4;
    transition: left 0.3s ease;
    box-shadow: 2px 0 5px rgba(206, 11, 11, 0.1);
    z-index: 10000;
}

.ChatBotComponent_rightSidePanelContent__2KH5X {
    padding: 20px;
}

/* Hover effect */
.ChatBotComponent_rightSidePanelTrigger__9ZQgp:hover+.ChatBotComponent_rightSidePanel__yduMd,
.ChatBotComponent_rightSidePanel__yduMd:hover {
    right: 0;
}


.ChatBotComponent_outerDiv__c7T\\+o {
    width: 100%;
}

.ChatBotComponent_outerDiv__c7T\\+o>* {
    display: inline-block;
}


.ChatBotComponent_plusIcon__4dB26 {
    height: 35px;
    width: 35px;
}

.ChatBotComponent_newChatIcon__3\\+4np {
    /* margin-right: 5px; */
    margin-left: -13px !important;
    position: relative;
    /* bottom: 15px; */
}

.ChatBotComponent_disableMicBtn__R4x7w {
    margin-bottom: -10px;
}

.ChatBotComponent_activeMicIcon__rb2IH {
    margin-bottom: -10px;
    background-color: #e9e9e9 !important;
    color: #626262 !important;
    cursor: unset !important;
    pointer-events: none;
}

.ChatBotComponent_chat_message__0mJUy {
    flex: 1 1;
    padding: 10px;
    overflow-y: scroll;
    border-right: 1px solid #ccc;
    /* To separate input from chat history */
}

.ChatBotComponent_histText__NUKC- {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 10px !important;
    /* width: 100px; */

    span {
        font-size: 12px !important
    }
}

.ChatBotComponent_semiDividerHome__7aEn- {
    position: relative;
    height: 1px;
    background-color: #acacac;
    border-radius: 10px
}

.ChatBotComponent_typing_effect__Z5uWu {
    font-family: Arial, sans-serif;
    font-size: 1rem;
    white-space: nowrap;
    overflow: hidden;
    animation: ChatBotComponent_typing__s4Lq9 3s steps(20, end) backwards;
    display: inline-block;
    padding-bottom: 20px;
    color: #0047ba;
}

@keyframes ChatBotComponent_typing__s4Lq9 {
    from {
        width: 0%;
    }

    to {
        width: 100%;
    }
}

.ChatBotComponent_chipCls__W3cTi {
    margin-right: 10px !important;
    cursor: pointer
}

.ChatBotComponent_chipCls__W3cTi:hover {
    background-color: #f4f4f4;
}

.ChatBotComponent_intro__ERmBV {
    text-align: center;
    padding: 5px 0px;
}

.ChatBotComponent_alignCenter__Igjg8 {
    margin: 0 auto;
}

.ChatBotComponent_intro__ERmBV div {
    color: #3A3A3A;
    text-align: center;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
}

.ChatBotComponent_intro__ERmBV p {
    color: #616161;
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
}

.ChatBotComponent_sendIcon__LJKzA {
    height: 25px;
    border-radius: 4px;
    width: 30px;
    cursor: pointer;
    /* margin-bottom: -25px; */
}

.ChatBotComponent_avatar__fwUXg {
    float: right;
    position: relative;
    top: -2px;
    margin: 0px 0px 0px 10px;
}

.ChatBotComponent_avatar__fwUXg img {
    height: 40px;
    width: 40px;
    padding-bottom: 3px;
}

.ChatBotComponent_aiavatar__CAPhk {
    float: left;
    position: relative;
    top: 7px;
    margin: 0px 10px 0px 0px;
    max-height: 40px;
    max-width: 40px;
    padding-right: 5px;
}

.ChatBotComponent_aiavatar__CAPhk img {
    height: 30px;
    width: 30px;
}

.ChatBotComponent_moreOptions__sUxTi {
    bottom: -6px;
    height: 10px;
    width: 10px;
    right: 35px;
}

.ChatBotComponent_moreOptions__sUxTi:focus {
    outline: none;
}

.ChatBotComponent_aiChatMessage__kfNrM {
    display: block;
}

.ChatBotComponent_aiChatMessage__kfNrM>* {
    display: inline-block;
}

.ChatBotComponent_suggestionBtn__CAEhl {
    margin-bottom: 16px;
    margin-left: 30px;
    padding-right: 30px;
}

.ChatBotComponent_suggestionBtn__CAEhl>button {
    border: 1px solid #D7E5F8;
    border-radius: 4px;
    background-color: #fff;
    text-align: left;
    font-size: 10px;
    width: -webkit-fill-available;
}

.ChatBotComponent_suggestionIcon__2ykMz {
    float: left;
    position: relative;
    top: 7px;
    margin: 0px 10px 0px 0px;
    padding: 4px;
    font-size: 10px;
    border-radius: 15px;
    background: #4197b2;
}

.ChatBotComponent_suggestionIcon__2ykMz>svg {
    background-color: #4197b2;
    color: #fff;
    font-size: 17px;
}

.ChatBotComponent_anchorul__\\+AdCV {
    list-style-type: none;
    float: right;
    position: fixed;
    right: 0px;
    max-width: 150px;
    margin-right: 20px;
}

.ChatBotComponent_anchorul__\\+AdCV>li>div {
    border: none;
    padding: 5px;
    background: #fff;
    border-left: 2px solid #acc6e1;
    font-size: 12px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 110px;
    cursor: pointer;
}

.ChatBotComponent_anchorul__\\+AdCV>li:active {
    border: none !important;
    outline: none !important;
}

.ChatBotComponent_activeLinkClass__we5Ux {
    border-left: 2px solid #005CBC !important;
}

.ChatBotComponent_feedback__Ar5q1 {
    position: relative;
    left: -10%;
    top: -10px;
    z-index: 0;
}

.ChatBotComponent_inputFieldContainer__iI7if {
    display: flex;
    justify-content: center;
    width: 100%;
    text-align: center;
    margin-left: 4%;
}

.ChatBotComponent_inputFieldGrid__oi0zY {
    background: #fff;
    bottom: 13px;
    position: relative;
    margin: 0 auto !important;
    display: block !important;
    width: 70% !important;
}

.ChatBotComponent_autoCompleteItem__akIyU {
    width: 80%;
    display: inline-block;
    padding: 0px 8px !important;
}

.ChatBotComponent_query__n3UvA {
    border: 1px solid;
    border-radius: 4px;
    padding: 2%;
    cursor: pointer;


    &:hover {
        background-color: lightgrey;
    }
}

.ChatBotComponent_emptyQueries__urkg9 {
    margin: auto;
    width: 50%;
    padding: 10px;
}

.ChatBotComponent_clearAll__5OgJK {
    float: right;
    background: unset !important;
    color: #0047ba !important;
    font-weight: 700;
    border: unset;
    padding: unset;
    
    &:focus {
        color: black;
        background: transparent;
        outline: none;
        box-shadow: none;
    }
}

.ChatBotComponent_dropdown__C5ae4 {
    float: left;
    position: relative;
    top: 7px;
    margin: 0px 10px 10px 50px;    
    display:inline;
    justify-content: center;
}

.ChatBotComponent_formControl__4URLK{
    margin-right: 10px;
    height: 20px;
}

.ChatBotComponent_loadingContainer__oD2Wk {
    margin-top: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 30px;
}

.ChatBotComponent_loadingMessage__73zIR {
    font-size: 14px;
    font-weight: bold;
    /* color: #585858a4; */
    color: transparent;
    /* background: linear-gradient(90deg, rgb(133, 128, 128) 0%, white 50%, rgb(133, 128, 128) 100%); */
    /* background: linear-gradient(90deg, black 0%, white 50%, black 100%); */
    background: black;
    background-size: 200% 100%;
    -webkit-background-clip: text;
    background-clip: text;
    /* animation: shine 3s infinite linear; */
    /* animation-duration: 4s; */
}
  
  @keyframes ChatBotComponent_shine__HsAx8 {
    0% {
      background-position: 200%;
    }
    100% {
      background-position: -200%;
    }
  }

.ChatBotComponent_loadingMessage__73zIR.ChatBotComponent_disabled__gwGJb {
  animation: none;
}


@media screen and (min-width: 350px) and (max-width: 500px) {

    /* .wrapper{
        margin-top: 60px;
    } */
    .ChatBotComponent_aiavatar__CAPhk {
        margin-right: -5px;
        margin: 0;
    }

    .ChatBotComponent_autoCompleteItem__akIyU {
        width: 100%;
    }

    .ChatBotComponent_suggestions__D5lOj {
        max-width: 80%;
    }

    .ChatBotComponent_messages__y1IRN {
        padding-left: unset;
        padding-right: unset;
        height: 80vh;
    }

    .ChatBotComponent_receivedMessage__gomBX {
        max-width: 75%;
    }

    .ChatBotComponent_inputFieldContainer__iI7if {
        margin-left: unset;
    }

    .ChatBotComponent_inputFieldGrid__oi0zY {
        width: 100% !important;
    }

    .ChatBotComponent_moreOptionsWeb__1wyCn {
        display: none;
    }

    .ChatBotComponent_moreOptionsMobile__F4Qi9 {
        float: right;
        margin-bottom: unset;
        margin-right: -30px;
    }

    .ChatBotComponent_anchorul__\\+AdCV {
        display: none;
    }

    .ChatBotComponent_feedback__Ar5q1 {
        position: relative;
        left: -10%;
        top: 40px;
        z-index: 0;
    }

    /* .newChatIcon {
        margin-right: 5px;
        position: absolute;
        top: -25px;
    } */

    /* .disableMicBtn{
        position: relative;
        top: 20px;
    } */

    /* .activeMicIcon{
        position: relative;
        top: 20px;
    } */

    /* .sendIcon {
        position: relative;
        top: 18px;
    } */

}



@media screen and (min-width: 500px) {
    .ChatBotComponent_moreOptionsMobile__F4Qi9 {
        display: none;
    }

    .ChatBotComponent_feedback__Ar5q1 {
        position: relative;
        left: -5%;
        top: 37px;
        z-index: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/ChatBotComponent/ChatBotComponent.module.css"],"names":[],"mappings":"AAAA;IACI;;;;;;0BAMsB;IACtB,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,WAAW;AACf;;AAEA;IACI;;;;kBAIc;IACd,eAAe;IACf,aAAa;IACb,WAAW;AACf;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;;AAE3B;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;;;;;;;GAOG;;AAEH;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,uBAAuB;IACvB,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,aAAa;AACjB;;;AAGA;IACI,cAAc;AAClB;;AAEA,eAAe;AACf;IACI,eAAe;IACf,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,aAAa;IACb,4BAA4B;IAC5B,uBAAuB;IACvB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,MAAM;IACN,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,0BAA0B;IAC1B,4CAA4C;AAChD;;AAEA;IACI,aAAa;AACjB;;AAEA,iBAAiB;AACjB;;IAEI,OAAO;AACX;;AAEA;IACI,eAAe;IACf,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,aAAa;IACb,MAAM;IACN,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,0BAA0B;IAC1B,4CAA4C;IAC5C,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA,iBAAiB;AACjB;;IAEI,QAAQ;AACZ;;;AAGA;IACI,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;;AAGA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,6BAA6B;IAC7B,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,oCAAoC;IACpC,yBAAyB;IACzB,wBAAwB;IACxB,oBAAoB;AACxB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,kBAAkB;IAClB,4BAA4B;IAC5B,wCAAwC;AAC5C;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,0BAA0B;IAC1B,kBAAkB;;IAElB;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,qEAA6C;IAC7C,qBAAqB;IACrB,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI;QACI,SAAS;IACb;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,wBAAwB;IACxB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,wBAAwB;IACxB,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,eAAe;IACf,UAAU;IACV,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,UAAU;AACd;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,eAAe;;;IAGf;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,4BAA4B;IAC5B,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;IACb,cAAc;;IAEd;QACI,YAAY;QACZ,uBAAuB;QACvB,aAAa;QACb,gBAAgB;IACpB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,0BAA0B;IAC1B,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,mGAAmG;IACnG,yEAAyE;IACzE,iBAAiB;IACjB,0BAA0B;IAC1B,6BAA6B;IAC7B,qBAAqB;IACrB,yCAAyC;IACzC,4BAA4B;AAChC;;EAEE;IACE;MACE,yBAAyB;IAC3B;IACA;MACE,0BAA0B;IAC5B;EACF;;AAEF;EACE,eAAe;AACjB;;;AAGA;;IAEI;;OAEG;IACH;QACI,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,oBAAoB;QACpB,YAAY;IAChB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,oBAAoB;QACpB,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,SAAS;QACT,UAAU;IACd;;IAEA;;;;OAIG;;IAEH;;;OAGG;;IAEH;;;OAGG;;IAEH;;;OAGG;;AAEP;;;;AAIA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,SAAS;QACT,UAAU;IACd;AACJ","sourcesContent":[".chatbotMiddle {\n    /* display: flex;\n    justify-content: center;\n    margin: 10px 0;\n    position: relative;\n    bottom: auto;\n    height: 90%;\n    align-items: center; */\n    /* width: 100%; */\n    position: fixed;\n    bottom: -10px;\n    width: 100%;\n}\n\n.chatbotBottom {\n    /* display: flex;\n    justify-content: center;\n    margin: 10px 0;\n    bottom: 10px;\n    width: 100%; */\n    position: fixed;\n    bottom: -10px;\n    width: 100%;\n}\n\n.messages {\n    flex: 1;\n    overflow-y: auto;\n    margin-bottom: 10px;\n    padding: 20px;\n    height: 73vh;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    padding-left: 10%;\n    padding-right: 10%;\n    /* overflow: initial; */\n\n}\n\n.tipsClass{\n    text-align:\"left\";\n    margin-left: 25px;\n}\n\n.tipsIcon{\n    height: 15px !important;\n    width: 15px !important;\n    margin-bottom: 5px;\n    margin-right: 2px;\n    margin-left: -6px;\n}\n\n/* .messages::-webkit-scrollbar {\n    display: none;\n}\n\n.messages {\n  -ms-overflow-style: none; \n  scrollbar-width: none; \n} */\n\n.messages img {\n    width: 70% ;\n    height: 70% ;\n}\n\n.sentMessage {\n    padding: 2px 10px;\n    margin-bottom: 5px;\n    border-radius: 30px;\n    max-width: 70%;\n    position: relative;\n    background-color: #e3e3e3;\n    border: 0 solid #e3e3e3;\n    min-width: 8%;\n    float: right;\n    text-align: center;\n    overflow-wrap: anywhere;\n    border-radius: 5px;\n    border: 1px solid #D7E5F8;\n    background: #EFF5FC;\n    color: #3A3A3A;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n}\n\n.receivedMessage {\n    margin: 5px 0;\n    padding: 5px 25px;\n    border-radius: 5px;\n    position: relative;\n    border: 1px solid #D7E5F8;\n    background-color: #faf9f9;\n    min-width: 8%;\n    overflow-wrap: anywhere;\n    max-width: 80%;\n}\n\n.mainDiv {\n    width: 100%;\n    margin-top: 70px;\n    font-size: 12px;\n}\n\n.userFeedbackContainer {\n    background-color: #f7f7f7;\n    height: 100vh;\n}\n\n\n.gridContainer {\n    height: 93.2vh;\n}\n\n/* side panel */\n.sidePanelTrigger {\n    position: fixed;\n    left: 10px;\n    top: 10%;\n    transform: translateY(-50%);\n    width: 30px;\n    height: 100px;\n    /* background-color: #000; */\n    content: \"Joe's Task: \";\n    cursor: pointer;\n    writing-mode: vertical-rl;\n    display: flex;\n    justify-content: center;\n}\n\n.sidePanel {\n    position: fixed;\n    left: -250px;\n    top: 0;\n    width: 200px;\n    height: 70%;\n    margin-top: 3% !important;\n    background-color: #f4f4f4;\n    transition: left 0.3s ease;\n    box-shadow: 2px 0 5px rgba(206, 11, 11, 0.1);\n}\n\n.sidePanelContent {\n    padding: 20px;\n}\n\n/* Hover effect */\n.sidePanelTrigger:hover+.sidePanel,\n.sidePanel:hover {\n    left: 0;\n}\n\n.rightSidePanelTrigger {\n    position: fixed;\n    right: 10px;\n    top: 10%;\n    transform: translateY(-50%);\n    width: 30px;\n    height: 100px;\n    cursor: pointer;\n    writing-mode: vertical-rl;\n    display: flex;\n    justify-content: center;\n}\n\n.rightSidePanel {\n    position: fixed;\n    right: -600px;\n    top: 0;\n    width: 30%;\n    height: 93%;\n    margin-top: 3% !important;\n    background-color: #f4f4f4;\n    transition: left 0.3s ease;\n    box-shadow: 2px 0 5px rgba(206, 11, 11, 0.1);\n    z-index: 10000;\n}\n\n.rightSidePanelContent {\n    padding: 20px;\n}\n\n/* Hover effect */\n.rightSidePanelTrigger:hover+.rightSidePanel,\n.rightSidePanel:hover {\n    right: 0;\n}\n\n\n.outerDiv {\n    width: 100%;\n}\n\n.outerDiv>* {\n    display: inline-block;\n}\n\n\n.plusIcon {\n    height: 35px;\n    width: 35px;\n}\n\n.newChatIcon {\n    /* margin-right: 5px; */\n    margin-left: -13px !important;\n    position: relative;\n    /* bottom: 15px; */\n}\n\n.disableMicBtn {\n    margin-bottom: -10px;\n}\n\n.activeMicIcon {\n    margin-bottom: -10px;\n    background-color: #e9e9e9 !important;\n    color: #626262 !important;\n    cursor: unset !important;\n    pointer-events: none;\n}\n\n.chat_message {\n    flex: 1;\n    padding: 10px;\n    overflow-y: scroll;\n    border-right: 1px solid #ccc;\n    /* To separate input from chat history */\n}\n\n.histText {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font-size: 10px !important;\n    /* width: 100px; */\n\n    span {\n        font-size: 12px !important\n    }\n}\n\n.semiDividerHome {\n    position: relative;\n    height: 1px;\n    background-color: #acacac;\n    border-radius: 10px\n}\n\n.typing_effect {\n    font-family: Arial, sans-serif;\n    font-size: 1rem;\n    white-space: nowrap;\n    overflow: hidden;\n    animation: typing 3s steps(20, end) backwards;\n    display: inline-block;\n    padding-bottom: 20px;\n    color: #0047ba;\n}\n\n@keyframes typing {\n    from {\n        width: 0%;\n    }\n\n    to {\n        width: 100%;\n    }\n}\n\n.chipCls {\n    margin-right: 10px !important;\n    cursor: pointer\n}\n\n.chipCls:hover {\n    background-color: #f4f4f4;\n}\n\n.intro {\n    text-align: center;\n    padding: 5px 0px;\n}\n\n.alignCenter {\n    margin: 0 auto;\n}\n\n.intro div {\n    color: #3A3A3A;\n    text-align: center;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 700;\n}\n\n.intro p {\n    color: #616161;\n    text-align: center;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n}\n\n.sendIcon {\n    height: 25px;\n    border-radius: 4px;\n    width: 30px;\n    cursor: pointer;\n    /* margin-bottom: -25px; */\n}\n\n.avatar {\n    float: right;\n    position: relative;\n    top: -2px;\n    margin: 0px 0px 0px 10px;\n}\n\n.avatar img {\n    height: 40px;\n    width: 40px;\n    padding-bottom: 3px;\n}\n\n.aiavatar {\n    float: left;\n    position: relative;\n    top: 7px;\n    margin: 0px 10px 0px 0px;\n    max-height: 40px;\n    max-width: 40px;\n    padding-right: 5px;\n}\n\n.aiavatar img {\n    height: 30px;\n    width: 30px;\n}\n\n.moreOptions {\n    bottom: -6px;\n    height: 10px;\n    width: 10px;\n    right: 35px;\n}\n\n.moreOptions:focus {\n    outline: none;\n}\n\n.aiChatMessage {\n    display: block;\n}\n\n.aiChatMessage>* {\n    display: inline-block;\n}\n\n.suggestionBtn {\n    margin-bottom: 16px;\n    margin-left: 30px;\n    padding-right: 30px;\n}\n\n.suggestionBtn>button {\n    border: 1px solid #D7E5F8;\n    border-radius: 4px;\n    background-color: #fff;\n    text-align: left;\n    font-size: 10px;\n    width: -webkit-fill-available;\n}\n\n.suggestionIcon {\n    float: left;\n    position: relative;\n    top: 7px;\n    margin: 0px 10px 0px 0px;\n    padding: 4px;\n    font-size: 10px;\n    border-radius: 15px;\n    background: #4197b2;\n}\n\n.suggestionIcon>svg {\n    background-color: #4197b2;\n    color: #fff;\n    font-size: 17px;\n}\n\n.anchorul {\n    list-style-type: none;\n    float: right;\n    position: fixed;\n    right: 0px;\n    max-width: 150px;\n    margin-right: 20px;\n}\n\n.anchorul>li>div {\n    border: none;\n    padding: 5px;\n    background: #fff;\n    border-left: 2px solid #acc6e1;\n    font-size: 12px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    max-width: 110px;\n    cursor: pointer;\n}\n\n.anchorul>li:active {\n    border: none !important;\n    outline: none !important;\n}\n\n.activeLinkClass {\n    border-left: 2px solid #005CBC !important;\n}\n\n.feedback {\n    position: relative;\n    left: -10%;\n    top: -10px;\n    z-index: 0;\n}\n\n.inputFieldContainer {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    text-align: center;\n    margin-left: 4%;\n}\n\n.inputFieldGrid {\n    background: #fff;\n    bottom: 13px;\n    position: relative;\n    margin: 0 auto !important;\n    display: block !important;\n    width: 70% !important;\n}\n\n.autoCompleteItem {\n    width: 80%;\n    display: inline-block;\n    padding: 0px 8px !important;\n}\n\n.query {\n    border: 1px solid;\n    border-radius: 4px;\n    padding: 2%;\n    cursor: pointer;\n\n\n    &:hover {\n        background-color: lightgrey;\n    }\n}\n\n.emptyQueries {\n    margin: auto;\n    width: 50%;\n    padding: 10px;\n}\n\n.clearAll {\n    float: right;\n    background: unset !important;\n    color: #0047ba !important;\n    font-weight: 700;\n    border: unset;\n    padding: unset;\n    \n    &:focus {\n        color: black;\n        background: transparent;\n        outline: none;\n        box-shadow: none;\n    }\n}\n\n.dropdown {\n    float: left;\n    position: relative;\n    top: 7px;\n    margin: 0px 10px 10px 50px;    \n    display:inline;\n    justify-content: center;\n}\n\n.formControl{\n    margin-right: 10px;\n    height: 20px;\n}\n\n.loadingContainer {\n    margin-top: 10px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-left: 30px;\n}\n\n.loadingMessage {\n    font-size: 14px;\n    font-weight: bold;\n    /* color: #585858a4; */\n    color: transparent;\n    /* background: linear-gradient(90deg, rgb(133, 128, 128) 0%, white 50%, rgb(133, 128, 128) 100%); */\n    /* background: linear-gradient(90deg, black 0%, white 50%, black 100%); */\n    background: black;\n    background-size: 200% 100%;\n    -webkit-background-clip: text;\n    background-clip: text;\n    /* animation: shine 3s infinite linear; */\n    /* animation-duration: 4s; */\n}\n  \n  @keyframes shine {\n    0% {\n      background-position: 200%;\n    }\n    100% {\n      background-position: -200%;\n    }\n  }\n\n.loadingMessage.disabled {\n  animation: none;\n}\n\n\n@media screen and (min-width: 350px) and (max-width: 500px) {\n\n    /* .wrapper{\n        margin-top: 60px;\n    } */\n    .aiavatar {\n        margin-right: -5px;\n        margin: 0;\n    }\n\n    .autoCompleteItem {\n        width: 100%;\n    }\n\n    .suggestions {\n        max-width: 80%;\n    }\n\n    .messages {\n        padding-left: unset;\n        padding-right: unset;\n        height: 80vh;\n    }\n\n    .receivedMessage {\n        max-width: 75%;\n    }\n\n    .inputFieldContainer {\n        margin-left: unset;\n    }\n\n    .inputFieldGrid {\n        width: 100% !important;\n    }\n\n    .moreOptionsWeb {\n        display: none;\n    }\n\n    .moreOptionsMobile {\n        float: right;\n        margin-bottom: unset;\n        margin-right: -30px;\n    }\n\n    .anchorul {\n        display: none;\n    }\n\n    .feedback {\n        position: relative;\n        left: -10%;\n        top: 40px;\n        z-index: 0;\n    }\n\n    /* .newChatIcon {\n        margin-right: 5px;\n        position: absolute;\n        top: -25px;\n    } */\n\n    /* .disableMicBtn{\n        position: relative;\n        top: 20px;\n    } */\n\n    /* .activeMicIcon{\n        position: relative;\n        top: 20px;\n    } */\n\n    /* .sendIcon {\n        position: relative;\n        top: 18px;\n    } */\n\n}\n\n\n\n@media screen and (min-width: 500px) {\n    .moreOptionsMobile {\n        display: none;\n    }\n\n    .feedback {\n        position: relative;\n        left: -5%;\n        top: 37px;\n        z-index: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chatbotMiddle": `ChatBotComponent_chatbotMiddle__4oGeB`,
	"chatbotBottom": `ChatBotComponent_chatbotBottom__MVlRN`,
	"messages": `ChatBotComponent_messages__y1IRN`,
	"tipsClass": `ChatBotComponent_tipsClass__W+kCb`,
	"tipsIcon": `ChatBotComponent_tipsIcon__EdBGW`,
	"sentMessage": `ChatBotComponent_sentMessage__5xVJl`,
	"receivedMessage": `ChatBotComponent_receivedMessage__gomBX`,
	"mainDiv": `ChatBotComponent_mainDiv__Ova9Z`,
	"userFeedbackContainer": `ChatBotComponent_userFeedbackContainer__QdU-n`,
	"gridContainer": `ChatBotComponent_gridContainer__tmior`,
	"sidePanelTrigger": `ChatBotComponent_sidePanelTrigger__xxboi`,
	"sidePanel": `ChatBotComponent_sidePanel__n7chF`,
	"sidePanelContent": `ChatBotComponent_sidePanelContent__l4PlS`,
	"rightSidePanelTrigger": `ChatBotComponent_rightSidePanelTrigger__9ZQgp`,
	"rightSidePanel": `ChatBotComponent_rightSidePanel__yduMd`,
	"rightSidePanelContent": `ChatBotComponent_rightSidePanelContent__2KH5X`,
	"outerDiv": `ChatBotComponent_outerDiv__c7T+o`,
	"plusIcon": `ChatBotComponent_plusIcon__4dB26`,
	"newChatIcon": `ChatBotComponent_newChatIcon__3+4np`,
	"disableMicBtn": `ChatBotComponent_disableMicBtn__R4x7w`,
	"activeMicIcon": `ChatBotComponent_activeMicIcon__rb2IH`,
	"chat_message": `ChatBotComponent_chat_message__0mJUy`,
	"histText": `ChatBotComponent_histText__NUKC-`,
	"semiDividerHome": `ChatBotComponent_semiDividerHome__7aEn-`,
	"typing_effect": `ChatBotComponent_typing_effect__Z5uWu`,
	"typing": `ChatBotComponent_typing__s4Lq9`,
	"chipCls": `ChatBotComponent_chipCls__W3cTi`,
	"intro": `ChatBotComponent_intro__ERmBV`,
	"alignCenter": `ChatBotComponent_alignCenter__Igjg8`,
	"sendIcon": `ChatBotComponent_sendIcon__LJKzA`,
	"avatar": `ChatBotComponent_avatar__fwUXg`,
	"aiavatar": `ChatBotComponent_aiavatar__CAPhk`,
	"moreOptions": `ChatBotComponent_moreOptions__sUxTi`,
	"aiChatMessage": `ChatBotComponent_aiChatMessage__kfNrM`,
	"suggestionBtn": `ChatBotComponent_suggestionBtn__CAEhl`,
	"suggestionIcon": `ChatBotComponent_suggestionIcon__2ykMz`,
	"anchorul": `ChatBotComponent_anchorul__+AdCV`,
	"activeLinkClass": `ChatBotComponent_activeLinkClass__we5Ux`,
	"feedback": `ChatBotComponent_feedback__Ar5q1`,
	"inputFieldContainer": `ChatBotComponent_inputFieldContainer__iI7if`,
	"inputFieldGrid": `ChatBotComponent_inputFieldGrid__oi0zY`,
	"autoCompleteItem": `ChatBotComponent_autoCompleteItem__akIyU`,
	"query": `ChatBotComponent_query__n3UvA`,
	"emptyQueries": `ChatBotComponent_emptyQueries__urkg9`,
	"clearAll": `ChatBotComponent_clearAll__5OgJK`,
	"dropdown": `ChatBotComponent_dropdown__C5ae4`,
	"formControl": `ChatBotComponent_formControl__4URLK`,
	"loadingContainer": `ChatBotComponent_loadingContainer__oD2Wk`,
	"loadingMessage": `ChatBotComponent_loadingMessage__73zIR`,
	"disabled": `ChatBotComponent_disabled__gwGJb`,
	"suggestions": `ChatBotComponent_suggestions__D5lOj`,
	"moreOptionsWeb": `ChatBotComponent_moreOptionsWeb__1wyCn`,
	"moreOptionsMobile": `ChatBotComponent_moreOptionsMobile__F4Qi9`,
	"shine": `ChatBotComponent_shine__HsAx8`
};
export default ___CSS_LOADER_EXPORT___;
